import {initDateTimePicker, initPrices} from "./Initialize";

document.addEventListener('Plandent.reinit.prices', initPrices, {passive: true});
document.addEventListener('plandent.html.changed', initPrices, {passive: true});
document.addEventListener('plandent.html.changed', initDateTimePicker, {passive: true});
